export default {
    namespaced: true,
    state: {
        username: 'sunsboy',
        token: ''
    },
    mutations: {

    },
    actions: {

    }
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js